// Eén herkansing voor een aanroep die op een koude start strandde.
//
// De drie padfuncties doen een zware cross-tenant scan en draaien op een
// instantie die naar nul schaalt. Komt er na een tijd stilte een verzoek
// binnen, dan breekt Cloud Run het soms af vóórdat de container klaar is —
// 'The request was aborted because there was no available instance'. De client
// ziet dan `internal`. Een langere timeout helpt daar niet tegen: het verzoek
// bereikt de functie niet eens.
//
// Deze module slikt GEEN fouten. Hij probeert één keer opnieuw bij codes die
// van voorbijgaande aard zijn, en laat daarna precies zien wat er misging. Een
// permission-denied of een echte codefout gaat dus meteen door naar het scherm.
// De aanroepen zijn read-only, dus twee keer proberen is ongevaarlijk.
//
// Duurzamer zou `minInstances: 1` op die functies zijn — dan is er altijd een
// warme container. Dat kost doorlopend geld en is een keuze van de user.
//
// AI-CONTEXT: See docs/features/toc-pad-bevinding-publiceren.md

// Codes die zeggen 'probeer het nog eens', niet 'dit klopt niet'.
const VOORBIJGAAND = ['internal', 'unavailable', 'deadline-exceeded', 'aborted', 'resource-exhausted']

const wacht = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

/**
 * @param {(payload: object) => Promise<object>} callable - de httpsCallable
 * @param {object} payload
 * @param {{delayMs?: number}} [opties] - delayMs alleen om in tests niet echt te wachten
 * @returns {Promise<object>}
 */
const callWithColdStartRetry = async (callable, payload, { delayMs = 4000 } = {}) => {
    try {
        return await callable(payload)
    } catch (err) {
        if (!VOORBIJGAAND.includes(err && err.code)) throw err
        // eslint-disable-next-line no-console
        console.warn('Aanroep strandde waarschijnlijk op een koude start, één herkansing:', err.code)
        await wacht(delayMs)
        return callable(payload)
    }
}

export { VOORBIJGAAND }
export default callWithColdStartRetry
